export const shouldLog = () => {
  let logging = localStorage.getItem("logging");
  //logging = "true"; //tedtest remove this when building
  return logging && logging !== "false";
};
